import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  inputed() {
    this.submitTarget.disabled = false
  }
}
